import React, {Component, useEffect, useState} from 'react';
import SelectWrapper from "../../Utils/Input/SelectWrapper";
import { withTranslation } from 'react-i18next';
import {Link} from "react-router-dom";

class Sorter extends Component {

    constructor(props) {
        super(props);

        this.state = {
            sortingField: this.props.sortField,
            sortingDirection: this.props.sortDirection
        }
    }
    componentDidUpdate(prevProps) {
        if ((prevProps.items.length === 0 && prevProps.items !== this.props.items)
            || (prevProps.currentDisplayMode != this.props.currentDisplayMode)
            || (prevProps.countSort !== this.props.countSort && prevProps.items !== this.props.items)
        ) {
            this.sortItems();
        }
        if (prevProps.sortField !== this.props.sortField) {
            this.setSortingField(this.props.sortField);
        }
        if (prevProps.sortDirection !== this.props.sortDirection) {
            this.setSortingDirection(this.props.sortDirection);
        }
    }
    setSortingField = (newField) => {
        this.setState({ sortingField: newField });
    }
    setSortingDirection = (newDirection) => {
        this.setState({ sortingDirection: newDirection });
    }

    onSortChangeHandler = (field = null) => {
        if(!field){
            return this.sortItems();
        } else {
            return this.setState({sortingField:field}, () => this.sortItems() );
        }
    }
    onDirectionSortChangeHandler = (field = null) => {
        if(!field){
            return this.sortItems();
        } else {
            return this.setState({sortingDirection:field}, () => this.sortItems() );
        }
    }

    sortItems = () => {
        if (this.props.setSortByCallback) {
            this.props.setSortByCallback(this.state.sortingField, this.state.sortingDirection)
        }
        if (!this.props.currentDisplayMode || this.props.currentDisplayMode === 'card') {
            let itemsNew = (this.props.items && Array.isArray(this.props.items)) ? [...this.props.items] : [];
            itemsNew.sort(this.sortingUtility());

            return this.props.getSortedItems((itemsNew && itemsNew.length) ? itemsNew : []);
        }
    }

    sortingUtility = () => {
        let property = this.state.sortingField;
        let currentType = 'string';
        let currentProperty = '';
        this.props.sortOptions.forEach((row) => {
            if (row.id === property) {
                currentProperty = row.value
                currentType = row.type
            }
        });
        let propertyDirection = this.state.sortingDirection;
        let sortOrder = 1;
        if (propertyDirection === 'DESC') {
            sortOrder = -1;
        }
        if (currentProperty != '') {

            return function (a,b) {
                /* Works with strings and numbers */
                const properties = currentProperty.split('.');

                let aVal, bVal;
                if (properties.length > 1) {
                    // There is a sub-accessor on the property and we need to fetch its value
                    switch(currentType){
                        case 'card':
                            aVal = a[properties[0]][properties[1]];
                            bVal = b[properties[0]][properties[1]];
                            aVal = aVal.slice(aVal.length -4)
                            bVal = bVal.slice(bVal.length -4)
                            break;
                        case 'int':
                            aVal = parseInt(a[properties[0]][properties[1]]);
                            bVal = parseInt(b[properties[0]][properties[1]]);
                            break;
                        case 'float':
                            aVal = parseFloat(a[properties[0]][properties[1]]);
                            bVal = parseFloat(b[properties[0]][properties[1]]);
                            break;
                        case 'date':
                            const d1 = new Date(a[properties[0]][properties[1]]);
                            const d2 = new Date(b[properties[0]][properties[1]]);
                            aVal = d1.getTime();
                            bVal = d2.getTime();
                            break;
                        case 'string':default:
                            aVal = String(a[properties[0]][properties[1]]);
                            bVal = String(b[properties[0]][properties[1]]);
                            break;
                    }
                } else {
                    // The property value is readable as-is
                    switch(currentType){
                        case 'card':
                            aVal = a[properties[0]];
                            bVal = b[properties[0]];
                            aVal = aVal.slice(aVal.length -4)
                            bVal = bVal.slice(bVal.length -4)
                            break;
                        case 'int':
                            aVal = parseInt(a[properties[0]]);
                            bVal = parseInt(b[properties[0]]);
                            break;
                        case 'float':
                            aVal = parseFloat(a[properties[0]]);
                            bVal = parseFloat(b[properties[0]]);
                            break;
                        case 'date':
                            const d1 = new Date(a[properties[0]]);
                            const d2 = new Date(b[properties[0]]);
                            aVal = d1.getTime();
                            bVal = d2.getTime();
                            break;
                        case 'string': default:
                            aVal = a[properties[0]];
                            bVal = b[properties[0]];
                            break;
                    }
                }
                let result = aVal > bVal && 1 || -1;
                return result * sortOrder;
            }
        }
    }


    render() {
        const sortOptions = (this.props.sortOptions.map((option, index) => {
            return (
                <option key={this.props.sortOptions[index]['id']} value={this.props.sortOptions[index]['id']}>
                    {this.props.sortOptions[index]['label']}
                </option>
            );
        }));

        return (
            <div className="toolbar__sorter sorter">
                <strong className="label">{this.props.t('misc.sort')}</strong>
                <SelectWrapper>
                    <select id="sortedby" onChange={(e) => this.onSortChangeHandler(e.target.value)}
                            value={this.state.sortingField}>
                        {sortOptions}
                    </select>
                </SelectWrapper>

                <Link className="direction" to={'#'} onClick={() => this.onDirectionSortChangeHandler(this.state.sortingDirection==='ASC'?'DESC':'ASC')} >
                    <i className={`fa fa-2x fa-sort-amount-${this.state.sortingDirection==='DESC'?'down':'up'}-alt`}></i>
                </Link>
            </div>
        );
    }
}

export default withTranslation()(Sorter);
